import ErrorText from "./ErrorText";
import Footer from "./Footer";
import Header from "./Header";
import Container from '@mui/material/Container';
import MemberCustomerCareBoilerPlate from "./MemberCustomerCareBoilerPlate";

//The function creates a global error with an optional error message.
export default function Error() {
    return (
        <>
            <Header message={"Error"} />
                <Container maxWidth={false}>
                    <ErrorText />
                    <MemberCustomerCareBoilerPlate />
                </Container>
            <Footer/>
        </>
    );
}